import React from 'react';
import Button from 'components/styleguide/button/Button';
import Tooltip from 'components/styleguide/tooltip/Tooltip';

const styles = require('./EorTooltip.module.scss');
const iconInfo = require('svg/icons-lj-styleguide-2025/info.svg');

export default function EorTooltip() {
  const handleTryEor = () => {
    document.dispatchEvent(new Event('eor-calculator:open'));
  };

  return (
    <Tooltip
      triggerAriaLabel="More info about Employer of Record"
      triggerIcon={<img src={iconInfo} alt="" width="18" height="18" />}
      role="dialog"
      popoverClassName={styles.popover}
      trapFocus
    >
      <h4 className={styles.title}>Hiring without legal entity?</h4>
      <p className={styles.text}>Calculate the true cost of hiring talent in Portugal with EOR.</p>
      <Button context="neutral" type="primary" size="S" onClick={handleTryEor}>
        Try EOR
      </Button>
    </Tooltip>
  );
}
